import { memo } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';

import { I18n, ProfileAvatar, ParticipantAvatar } from '../components';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__, __ANDROID__ } from '../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getCurrentTopic } from './selector';

function mapStateToProps(state) {
  return {
    navMode: state.screens.messaging.navMode,
    members: getCurrentTopic(state)?.members || [],
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({}, dispatch),
  };
}

export default memo(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )((props) => {
    function renderMember(member) {
      if (member.participant) {
        return (
          <ParticipantAvatar
            key={member.participant.userId}
            participant={member}
            circleStyles={styles.avatar}
            onPress={null}
            showNameLabel={true}
            isAirforce={props.isAirforce}
            containerStyles={styles.avatarContainer}
            displayType={props.navMode}
          />
        );
      }
      return (
        <ProfileAvatar
          key={member.userId}
          profile={member}
          circleStyles={styles.avatar}
          showNameLabel={true}
          isAirforce={props.isAirforce}
          containerStyles={styles.avatarContainer}
          displayType={props.navMode}
        />
      );
    }

    return (
      <View style={styles.container}>
        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={styles.horizontalScrollViewContent}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          horizontal={true}
        >
          {props.members.map(renderMember)}
        </ScrollView>
      </View>
    );
  })
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  horizontalScrollViewContent: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  avatar: {
    width: 45,
    height: 45,
  },
  avatarContainer: {
    marginHorizontal: 20,
  },
});
